import ExportFieldLabel from './ExportFieldLabel'
import ExportHoverTooltip from './ExportHoverTooltip'
import { EXPORT_REPORT_SETTINGS_TOOLTIPS } from './exportReportSettingsTooltips'
import './ExportDataScope.css'

const FORMAT_OPTIONS = [
  {
    value: 'pdf',
    id: 'export-format-pdf',
    label: 'PDF',
    tooltip: EXPORT_REPORT_SETTINGS_TOOLTIPS.formatPdf,
  },
  {
    value: 'csv',
    id: 'export-format-csv',
    label: 'CSV',
    tooltip: EXPORT_REPORT_SETTINGS_TOOLTIPS.formatCsv,
  },
]

function ExportFormatOption({ id, name, value, checked, label, tooltip, onChange }) {
  return (
    <ExportHoverTooltip
      as="label"
      content={tooltip}
      className={`dashboardExportFormat${checked ? ' is-active' : ''}`}
      htmlFor={id}
    >
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {label}
    </ExportHoverTooltip>
  )
}

export default function ExportFormatSection({ value, onChange }) {
  return (
    <div className="dashboardExportField dashboardExportField--segmented">
      <ExportFieldLabel tooltip={EXPORT_REPORT_SETTINGS_TOOLTIPS.format}>
        Format
      </ExportFieldLabel>
      <div className="dashboardExportFormats">
        {FORMAT_OPTIONS.map((option) => (
          <ExportFormatOption
            key={option.value}
            id={option.id}
            name="export-format"
            value={option.value}
            checked={value === option.value}
            label={option.label}
            tooltip={option.tooltip}
            onChange={() => onChange(option.value)}
          />
        ))}
      </div>
    </div>
  )
}
